export default "__VITE_ASSET__357c1763__"